/**
 * "Refresh lists" on the Drop slots card (21/10/2026): every group of this
 * container picks its list again — the list each one is on is forgotten,
 * its burns kept, and the slots show the first list of the order as it is
 * now; a day already laid out re-syncs, its unsent drafts move.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { RefreshCw } from 'lucide-react';

import { Button, Tooltip } from '@/components/ui';
import { cn } from '@/lib/utils';

import { useRepick } from './use-repick';

export const REFRESH_LISTS_HINT =
  "Every group picks its list again: the list each one is on is forgotten (its burned lists stay burned) and the slots show the first list of the order as it is now. A day already laid out re-syncs — its unsent drafts move. Generate now and the daily auto-generate already start each formula group on its best list; a saved rule, order or formula does this by itself.";

export const RefreshListsButton: FC<{ countryKey: string; containerId: string }> = ({ countryKey, containerId }) => {
  const { repick, pending } = useRepick(countryKey, containerId);
  return (
    <Tooltip content={REFRESH_LISTS_HINT}>
      <Button size="sm" variant="outline" className="h-7 gap-1.5 px-2.5 text-xs" disabled={pending} onClick={() => void repick(null)}>
        <RefreshCw className={cn('h-3.5 w-3.5', pending && 'animate-spin')} aria-hidden />
        Refresh lists
      </Button>
    </Tooltip>
  );
};
